import React, { useEffect, useContext, useState } from 'react'
import CustomTable from '@/product/components/molecules/CustomTable'
import CustomSearch from '@/product/components/molecules/CustomSearch'
import ReportContext from '@/product/context/report/reportContext'
import FullScreenPopup from '@/product/components/organisms/FullScreenPopup'
import DynamicContext from '@/product/context/dynamic/dynamicContext'
import Loaders from '@/product/components/molecules/Loaders'
import { FormikContext, useFormik } from 'formik'
import { mapData } from '@/product/common/components'
import ProductContext from '@/product/context/product/productContext'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'

import {
    initialFunction,
    validationFunction,
    editValue,
} from '@/product/components/species/dynamic/common/FieldFunction'

import * as Yup from 'yup'

const ImageEdit = (props) => {
    const productContext = useContext(ProductContext)

    const dynamicContext = useContext(DynamicContext)

    const [isLoading, setIsLoading] = useState(false)
    const { project_dynamicfields } = dynamicContext

    const [fieldValue, setFieldValue] = useState([])
    const [reload, setReload] = useState(false)

    const {
        projectAction,
        single_project,
        getSingleProject,
        all_products,
        activelots,
        getAllProducts,
        responseStatus: responseStatusProduct,
    } = productContext

    useEffect(() => {
        if (project_dynamicfields && project_dynamicfields.length) {
            let projectDynamicArray = [...project_dynamicfields]
            let dynamicValueAssign = []

            projectDynamicArray
                .filter((data) => data.name === 'uploadimages')
                .map((item) => {
                    item.reorder = true
                    dynamicValueAssign.push(item)
                })

            const arrayData = [...dynamicValueAssign]

            let { tempMapData } = initialFunction(arrayData)
            setFieldValue(tempMapData)
        }
    }, [project_dynamicfields])

    let data = props.data

    let validationArray = {
        uploadimages: Yup.array().required('Required!'),
    }

    const formik = useFormik({
        initialValues: {
            id: 0,
            uploadimages: [],
        },
        validateOnBlur: false,
        validationSchema: Yup.object().shape({ ...validationArray }),
        enableReinitialize: true,
        onSubmit: (values) => {
            let value = values
            projectAction(value)
        },
    })

    const resetForm = () => {
        formik.resetForm()
        setReload(!reload)
    }

    useEffect(() => {
        if (data?.id) {
            formik.values.id = parseInt(data?.id)
            getSingleProject(formik.values, 'imageEditPage')
        } else {
            resetForm()
        }
    }, [data?.id])

    useEffect(() => {
        if (single_project.from === 'imageEditPage') {
            formik.setFieldValue(
                'uploadimages',
                single_project?.record?.uploadimages
                    ? single_project.record.uploadimages.toString().split(',')
                    : []
            )
            setReload(!reload)
        }
    }, [single_project, props?.data])

    return (
        <FullScreenPopup
            modaltitle={'EDIT IMAGE'}
            open={data.popup}
            handleClose={() => {
                props.function(false, 0)
                if (props?.updateFunction) {
                    props.updateFunction()
                }
            }}
        >
            <div className="addUserModal">
                <div className="fspBody">
                    {isLoading ? (
                        <div className="fspLoader">
                            <Loaders isLoading={isLoading} />
                        </div>
                    ) : (
                        <>
                            <form
                                onSubmit={formik.handleSubmit}
                                autoComplete="nofill"
                            >
                                <div className="row">
                                    {mapData({
                                        formik: formik,
                                        data: fieldValue,
                                    })}
                                </div>

                                <PrimaryButton
                                    id="base_submit"
                                    type="submit"
                                    label={'Submit'}
                                />
                            </form>
                        </>
                    )}
                </div>
            </div>
        </FullScreenPopup>
    )
}

export default ImageEdit
